function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.66667 1.75C1.66667 0.783502 2.41286 0 3.33333 0H8.33333C9.25381 0 10 0.783501 10 1.75V10.5C10 11.4665 9.25381 12.25 8.33333 12.25H3.33333C2.41286 12.25 1.66667 11.4665 1.66667 10.5V1.75Z",
  fill: "#939AA3"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 3.50001C0 2.85226 0.335166 2.28671 0.833333 1.98413V10.9375C0.833333 12.1456 1.76607 13.125 2.91667 13.125H8.11036C7.82219 13.6481 7.28357 14 6.66667 14H2.91667C1.30584 14 0 12.6289 0 10.9375V3.50001Z",
  fill: "#939AA3"
});

function SvgCopyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.469c7bc5.svg";
export { ForwardRef as ReactComponent };